<div class="dialog-content-max">
    <form [formGroup]="hubform">
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="name">Hub Name <span style="color: rgb(60, 137, 246); font-size: 9px !important;">(Max 100
                        chars)</span>
                    <span class="required-label">*</span></label>
                <input type="text" class="form-control" id="name" inputId="name" placeholder="Enter Hub Name"
                    name="name" formControlName="name" required>
                <!-- <span style="color:red" *ngIf="hubform.get('name').invalid && hubform.get('name').touched ">
                    {{getErrorMessage(hubform ,validation_message,'name')}}
                </span> -->
                <span class="errormessage"
                    *ngIf="hubform.get('name').invalid && (hubform.get('name').dirty || hubform.get('name').touched)">
                    {{ getErrorMessage(hubform, validation_message, 'name') }}
                </span>
            </div>

        </div>

        <div class="formgrid grid" *ngIf="isEdit">
            <div class="col-12 lg:col-12 md:col-12 sm:col-12">
                <label for="activeflag">Active Flag<span
                        style="color: rgb(222, 30, 30); font-weight: bold;">*</span></label>
                <p-dropdown [options]="activeFlag" inputId="activeflag" [filter]="true" appendTo="body"
                    name="activeflag" optionLabel="labelname" optionValue="value" placeholder="Select Flag"
                    formControlName="activeflag"></p-dropdown>

                <span style="color:red" *ngIf="hubform.get('activeflag').invalid  && hubform.get('activeflag').touched">
                    {{getErrorMessage(hubform,validation_message,'activeflag')}}
                </span>

            </div>

        </div>
    </form>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose" (click)="closemodal(hubform,this.ref,'Are you sure you want to close?')"></p-button>

        <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave"
            (click)="add()"></p-button>
    </div>
</div>